export default __webpack_public_path__ + "static/media/turn.b71cd901.mp3";